<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col xl="5" lg="7" md="8" sm="10" cols="12">
            <v-form @submit.prevent="$refs.form?.isValid && submit()" ref="form">
                <custom-divider label="تنظیمات سرور IMAP"></custom-divider>
                <p class="my-2 text-small text-grey-darken-1">تبدیل ایمیل های ورودی به تیکت های جدید، قابلیتی است که سازمان شما را در راه تسهیل ثبت اولیه تیکت های جدید مشتریان کمک خواهد نمود. در این مکانیزم، ایمیل های ورودی به آدرس های ایمیل سازمانی شما به صورت خودکار تبدیل به تیکت هایی خواهند شد که به دپارتمان های مختلف شما ارجاع می گردند.<br>نکته 1: به دلیل جلوگیری از تبدیل ایمیل های اسپم به تیکت، آدرس ایمیل مشتریان شما می باید در پروفایل ایشان در هلپیکال از قبل تعریف شده و از همان آدرس ها نسبت به ارسال ایمیل ها اقدام گردد.<br>نکته 2: در این ویژگی، اینباکس ایمیل های شما هر 15 دقیقه یک بار مورد بررسی قرار خواهند گرفت و ایمیل های جدید خوانده نشده در آنها به تیکت های جدید تبدیل خواهند گردید.<br>نکته 3: پاسخ و پیگیری تیکت های ثبت شده پس از اولین گام (ثبت تیکت) در پنل نرم افزار هلپیکال ادامه خواهند یافت.</p>
                <v-checkbox class="mt-3 mb-4" hide-details label="فعال سازی تبدیل ایمیل به تیکت جدید" v-model="form.ett_status"></v-checkbox>
                <v-row dense>
                    <v-col cols="9">
                        <v-text-field
                            :rules="$validation('url')"
                            label="آدرس سرور IMAP"
                            v-model="form.ett_server_address"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            :rules="$validation()"
                            label="پورت IMAP"
                            v-model="form.ett_server_port"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <custom-divider label="تظیمات دپارتمان ها"></custom-divider>
                <div>
                    <v-row dense v-for="(department ,index) in form.ett_departments" :key="index" class="mt-4">
                        <v-col cols="12" sm>
                            <v-autocomplete
                                :items="departmentList.filter(x => department.department_id == x.id || !form.ett_departments.filter(y => y.department_id == x.id).length)"
                                :rules="$validation()"
                                item-title="name"
                                item-value="id"
                                label="انتخاب دپارتمان"
                                no-data-text="موردی پیدا نشد!"
                                hide-details
                                clearable
                                v-model="department.department_id"
                                autocomplete="new-password"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm>
                            <v-text-field
                                :rules="$validation()"
                                label="نام کاربری (ایمیل)"
                                hide-details
                                v-model="department.username"
                                clearable
                                autocomplete="new-password"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                :rules="$validation()"
                                :type="department.visible ? 'text' : 'password'"
                                label="کلمه عبور"
                                hide-details
                                v-model="department.password"
                                :append-inner-icon="department.visible ? 'visibility' : 'visibility_off'"
                                @click:appendInner="department.visible = !department.visible"
                                clearable
                                autocomplete="new-password"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn v-tooltip="'حذف دپارتمان'" icon="clear" variant="text" color="error" :disabled="form.ett_departments.length == 1" @click="form.ett_departments.splice(index,1)"></v-btn>
                        </v-col>
                    </v-row>
                    <v-btn @click="form.ett_departments.push({department_id: null, username: null, password: null, visible: false})" :disabled="!!form.ett_departments.find(x => !x.department_id) || form.ett_departments.length == departmentList.length" class="rounded d-block mx-auto mt-4" color="secondary">
                        <v-icon size="18">add</v-icon> افزودن دپارتمان
                    </v-btn>
                </div>
                <div class="mt-6">
                    <v-btn color="success" type="submit" :loading="loading">ثبت اطلاعات</v-btn>
                    <v-btn @click="$router.push({path: '/settings'})" class="ms-3" color="error" variant="text" :disabled="loading">بازگشت به تنظیمات</v-btn>
                </div>
            </v-form>
        </v-col>
    </div>
</template>

<script>
export default {
    title: "تنظیمات ایمیل به تیکت",
    validate(context) {
      return context.auth.user.full_admin && context.system.license.features.email_to_ticket;
    },
    data() {
        return {
            loading: false,
            departmentList: [],
            form: {
                ett_status: this.$system.settings.ett_status,
                ett_server_address: this.$system.settings.ett_server_address,
                ett_server_port: this.$system.settings.ett_server_port,
                ett_departments: JSON.parse(JSON.stringify(this.$system.settings.ett_departments))
            },
        };
    },
    methods: {
        submit() {
            this.loading = true;
            let form = JSON.parse(JSON.stringify(this.form));
            form.ett_departments = form.ett_departments.filter(x => x.department_id).map(x => { delete x.visible; return x; });
            this.$updateSettings({...form, _method: 'put'}).then((res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    this.$system.setGlobalSettings(true);
                }
            }).finally(()=>{this.loading = false});
        },
    },
    created() {
        if (!this.form.ett_departments.length)
            this.form.ett_departments.push({department_id: null, username: null, password: null, visible: false});
        else this.form.ett_departments = this.form.ett_departments.map(x => ({...x, visible: false}));
        this.departmentList = this.$system.departments.filter(x => ![this.$system.customers_department.id, this.$system.managers_department.id].includes(x.id));
    }
};
</script>
